module.exports = __webpack_public_path__ + "img/18a001-08.13b31490.jpg";